import { render, staticRenderFns } from "./LaBase.vue?vue&type=template&id=856b90ca&scoped=true&"
import script from "./LaBase.vue?vue&type=script&lang=js&"
export * from "./LaBase.vue?vue&type=script&lang=js&"
import style0 from "./LaBase.vue?vue&type=style&index=0&id=856b90ca&prod&scoped=true&lang=css&"
import style1 from "./LaBase.vue?vue&type=style&index=1&id=856b90ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856b90ca",
  null
  
)

export default component.exports